const actions = {
	'SET_UID': (state, uid) => {
		return state.commit('SET_UID', uid)
	},
	'SET_TOKEN': (state, token) => {
		return state.commit('SET_TOKEN', token)
	},
	'SET_INFO': (state, info) => {
		return state.commit('SET_INFO', info)
	},
	'SET_MOBILE': (state, mobile) => {
		return state.commit('SET_MOBILE', mobile)
	},
	'SET_GENDER': (state, gender) => {
		return state.commit('SET_GENDER', gender)
	},
	'SET_NICKNAME': (state, nickname) => {
		return state.commit('SET_NICKNAME', nickname)
	},
	'SET_AVATAR': (state, avatar) => {
		return state.commit('SET_AVATAR', avatar)
	},
	'SET_BIRTHDAY': (state, birthday) => {
		return state.commit('SET_BIRTHDAY', birthday)
	},
	'SET_SEARCH': (state, search) => {
		return state.commit('SET_SEARCH', search)
	},
	'SET_AUTOCOMPLETE': (state, autoComplete) => {
		return state.commit('SET_AUTOCOMPLETE', autoComplete)
	},
	'SET_BOOKID': (state, id) => {
		return state.commit('SET_BOOKID', id)
	},
	'SET_DETAIL': (state, detail) => {
		return state.commit('SET_DETAIL', detail)
	},
	'SET_CHAPTERID': (state, chapterId) => {
		return state.commit('SET_CHAPTERID', chapterId)
	},
	'SET_CHANNELS': (state, channels) => {
		return state.commit('SET_CHANNELS', channels)
	},
	'SET_CHANNELID': (state, channelId) => {
		return state.commit('SET_CHANNELID', channelId)
	},
	'SET_ALLCOUNT': (state, allCount) => {
		return state.commit('SET_ALLCOUNT', allCount)
	},
	'SET_CLASSCOUNT': (state, classCount) => {
		return state.commit('SET_CLASSCOUNT', classCount)
	},
	'SET_BOOK_NAME': (state, book_name) => {
		return state.commit('SET_BOOK_NAME', book_name)
	},
	'SET_NOTES': (state, notes) => {
		return state.commit('SET_NOTES', notes)
	},
	'SET_AREA': (state, area) => {
		return state.commit('SET_AREA', area)
	},
	'SET_PARENT_NAME': (state, parent_name) => {
		return state.commit('SET_PARENT_NAME', parent_name)
	},
	'SET_STUDENT_NAME': (state, student_name) => {
		return state.commit('SET_STUDENT_NAME', student_name)
	},
	'SET_TEACHER': (state, teacher) => {
		return state.commit('SET_TEACHER', teacher)
	},
	'SET_MOBILE': (state, mobile) => {
		return state.commit('SET_MOBILE', mobile)
	},
	'SET_CHECKED': (state, checked) => {
		return state.commit('SET_CHECKED', checked)
	}
}

export default actions


// WEBPACK FOOTER //
// ./src/store/actions.js